import React, { useState, useEffect } from 'react'
import axios from 'axios'
import DefaultAvatar from '@/pages/profile/components/DefaultAvatar.tsx'

interface ImageInputProps {
  imageUrl?: string | null | undefined
  firstName?: string | null
  lastName?: string | null
}

const LoadImage: React.FC<ImageInputProps> = ({
  imageUrl,
  firstName,
  lastName,
}) => {
  const [image, setImage] = useState<string | null>(imageUrl || null)
  // Function to fetch the image from the API
  const fetchImage = async () => {
    if (imageUrl) {
      try {
        const response = await axios.get(imageUrl, {
          responseType: 'blob', // Ensure you get the image as a Blob
        })
        const imageObjectURL = URL.createObjectURL(response.data)
        setImage(imageObjectURL)
      } catch (error) {
        // Set image to placeholder if error occurs
        setImage(null)
      }
    }
  }
  useEffect(() => {
    fetchImage()
  }, [imageUrl])

  return (
    <div
      className={`w-full h-full rounded-full border-1 ${
        image ? 'border-success' : 'border-gray-300'
      } relative flex justify-center items-center`}
      style={{
        backgroundImage: `url(${image})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {image == null && (
        <DefaultAvatar firstName={firstName} lastName={lastName} />
      )}
    </div>
  )
}

export default LoadImage
